const END_POINT = process.env.END_POINT || "https://apicpanel.stoo.vn"

export default {
    END_POINT,
}